import React, {useContext} from 'react';
import {ISocketConnectionContext} from './socket.model';

const SocketContext = React.createContext<ISocketConnectionContext>(null as any);

export const SocketContextProvider = SocketContext.Provider;
export const SocketContextConsumer = SocketContext.Consumer;

export const useSocketContext = () => useContext<ISocketConnectionContext>(SocketContext);
